import type { DatapointOptions, CustomDataMap } from 'owa-analytics-types';
import GreyErrorDatapoint from '../datapoints/GreyErrorDatapoint';
import { logDatapoint } from './logDatapoint';
import type { AnalyticsEventNames } from 'owa-analytics-events';
import type { MailboxInfo } from 'owa-client-types';

const listeners: Array<
    (
        eventName: AnalyticsEventNames,
        mailbox: MailboxInfo | undefined,
        error?: Error,
        customData?: CustomDataMap,
        options?: DatapointOptions
    ) => void
> = [];

export function logGreyError(
    eventName: AnalyticsEventNames,
    mailbox: MailboxInfo | undefined,
    error?: Error,
    customData?: CustomDataMap,
    options?: DatapointOptions
): Promise<void> {
    for (const listener of listeners) {
        listener(eventName, mailbox, error, customData, options);
    }

    return logDatapoint(
        new GreyErrorDatapoint(
            eventName,
            mailbox,
            error || new Error('GreyError'),
            customData,
            options
        )
    );
}

export function registerGreyErrorListener(
    listener: (
        eventName: AnalyticsEventNames,
        mailbox: MailboxInfo | undefined,
        error?: Error,
        customData?: CustomDataMap,
        options?: DatapointOptions
    ) => void
): void {
    listeners.push(listener);
}
